import Vue from 'vue';

jQuery(document).ready(function() {



if(!jQuery('.find-right-treatment').length) {
	return;
}

window.findRightTreatmentCommonData = {
	indicationAreas: [],
	activeArea: false,
	activeIndications: [],
	selectedIndication: false,
	treatments: [],
	activeTreatments: [],
	indicationListExpanded: false,
	modalState: 0
}

window.findRightTreatmentCommonMethods = {
	
	setupFindRightTreatment() {

		if(window.profetPreload && window.profetPreload.indicationsAndTreatmentsdata) {

			/*
			for(var i in window.profetPreload.indicationsAndTreatmentsdata.treatments) {
				var treatment = window.profetPreload.indicationsAndTreatmentsdata.treatments[i];
				if(!_.contains(this.treatments, treatment)) {
					this.treatments.push(treatment);
				}
			}

			for(var i in window.profetPreload.indicationsAndTreatmentsdata.areas) {
				var area = window.profetPreload.indicationsAndTreatmentsdata.areas[i];
				if(!_.contains(this.indicationAreas, area)) {
					this.indicationAreas.push(area);
				}
			}
			*/

			this.treatments = window.profetPreload.indicationsAndTreatmentsdata.treatments;
			this.indicationAreas = window.profetPreload.indicationsAndTreatmentsdata.areas;

			this.orderAreas();



		}
		else {
			axios.get('/wp-json/nk/getAreasIndicationsAndTreatments/')
			.then( (response) => {
				this.treatments = response.data.data.treatments;
				this.indicationAreas = response.data.data.areas;
				this.orderAreas();
			});
		}
	},

	orderAreas() {
		/* Manually order the areas like the following array */
		var order = ['Bröst', 'Kropp', 'Ansikte', 'Ögon', 'Läppar', 'Hud', 'Hår'];
		for(var i in this.indicationAreas) {

			var index = order.indexOf(this.indicationAreas[i].name);
			if(index == -1) {
				this.indicationAreas[i].order = 100;				
			}
			else {
				this.indicationAreas[i].order = index;
			}

		}

		this.indicationAreas = _.sortBy(this.indicationAreas, o => parseInt(o.order, 10));

		var sortedIndicationAreas = [];

		_.each(this.indicationAreas, function(area){
			var newObject = [];
		  newObject[area.name] = {};
		  newObject[area.name].name = area.name;
		  newObject[area.name].indications = area.indications;
		  newObject[area.name].order = area.order;
		  sortedIndicationAreas.push(newObject[area.name]);
		});

		this.indicationAreas = sortedIndicationAreas;

	},

	setActiveArea(area) {
		this.activeArea = area.name;
		this.activeIndications = [];
		this.activeTreatments = [];
		this.selectedIndication = false;

		for(var i in this.indicationAreas) {

			for(var indication in this.indicationAreas[i]['indications']) {
				if(this.indicationAreas[i].name != area.name) {
					continue;
				}
				var singleIndication = this.indicationAreas[i]['indications'][indication];

				if(!_.find(this.activeIndications, { 'indication_id': singleIndication.indication_id})) {
					this.activeIndications.push(singleIndication);
				}
			}

		}

		/* Order active indications */
		this.activeIndications = _.sortBy(this.activeIndications, o => parseInt(o.indication_search_points, 10));
		this.activeIndications.reverse();
	},

	setActiveIndication(indication) {

		if(this.selectedIndication == indication) {
			this.selectedIndication = false;
			this.activeTreatments = false;
			return;
		}

		this.selectedIndication = indication;
		this.activeTreatments = [];

		for(var treatment in this.treatments) {

			for(var indicationId in this.treatments[treatment].indication_ids) {
				var id = this.treatments[treatment].indication_ids[indicationId];
				if(this.selectedIndication.indication_id == id) {
					this.activeTreatments.push(this.treatments[treatment]);	
				}
			}
			
		}

	},

	closeModal() {
		this.modalState = 0;
	}


}

new Vue({

	el: '.find-right-treatment',
	
	data: window.findRightTreatmentCommonData,

	methods: window.findRightTreatmentCommonMethods,

	created() {
		this.setupFindRightTreatment();
	},

});



});